import { useTranslation } from 'next-i18next';

import { useAppDispatch, useAppSelector } from '@/redux';
import { updateCartAttribute } from '@/redux/slices/cart.slice';

import { NS } from '@/constants';

import CheckboxV2 from '@/components/common/CheckboxV2';
import { updateExproOrder } from '@/redux/slices/expro.slice';

export const SendEmailCheckbox = ({ fromExpro = false }) => {
  const dispatch = useAppDispatch();
  const sendOrderEmail = useAppSelector(({ cart }) => cart.content.sendOrderEmail ?? true);
  const sendMailToCustomerFromExproOrder = useAppSelector(({ expro }) => expro.exproOrder.sendMailToCustomer);
  const { t } = useTranslation(NS.ADMIN);
  const exproOrder = useAppSelector(({ expro }) => expro.exproOrder);

  const handleUpdateExproOrder = (sendMail: boolean) => {
    dispatch(updateExproOrder({
      exproOrder: {
        ...exproOrder,
        sendMailToCustomer: sendMail
      }
    }));
  };

  const handleUpdateCart = (sendMail: boolean) => {
    dispatch(updateCartAttribute({ attributeName: 'sendOrderEmail', newValue: sendMail }));
  };

  const isChecked = sendOrderEmail || sendMailToCustomerFromExproOrder;

  return (
    <CheckboxV2
      id="send-email-customer"
      label={t('checkout.summary.sendCustomerEmail')}
      checked={isChecked}
      onChange={(e) => fromExpro ? handleUpdateExproOrder(e.target.checked) : handleUpdateCart(e.target.checked)}
    />
  );
};

export default SendEmailCheckbox;
